<template>
   <div id="app">
      <!-- 头部导航 -->
      <div class="sa-header" data-v-9c14ebd6>
         <div class="el-row header-pc" style="" data-v-9c14ebd6>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-9c14ebd6></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18 content" style="" data-v-9c14ebd6>
               <div class="sa-flex" data-v-9c14ebd6>
                  <img class="logo" src="@/assets/image/home/logo.png" data-v-9c14ebd6>
               </div>
               <ul role="menubar" style="--el-menu-level:0;" class="el-menu el-menu--horizontal" data-v-9c14ebd6>

                  <li class="el-menu-item" :class="[ $store.state.navState == index && 'is-active']" role="menuitem" data-v-9c14ebd6
                  v-for="(nav,index) in navlist" :key="index" @click="jump(nav.path,index)">
                     <div data-v-9c14ebd6>{{nav.meta.title}}</div>
                  </li>
                  <a class="menu-item" href="https://www.hlnwl.com" target="_blank" data-v-9c14ebd6>
                     官方网站
                     <i class="iconfont icon-fenxiang_2" data-v-9c14ebd6></i>
                  </a>
               </ul>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-9c14ebd6></div>
         </div>
         <!-- 移动端适配 -->
         <div class="el-row header-mobile" style="" data-v-9c14ebd6>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-9c14ebd6>
               <div class="nav-top sa-flex sa-row-between" data-v-9c14ebd6>
                  <img class="logo" src="@/assets/image/home/logo.png" data-v-9c14ebd6>
                  <div class="nav-icon" :class="[showmenu && 'is-active']" data-v-9c14ebd6 @click="showmenu = !showmenu">
                     <div class="line" data-v-9c14ebd6>
                        <span data-v-9c14ebd6></span>
                     </div>
                     <div class="line" data-v-9c14ebd6>
                        <span data-v-9c14ebd6></span>
                     </div>
                  </div>
               </div>
               <div class="nav-content el-overlay" :style="{height}">
                  <div data-v-9c14ebd6="" class="nav-item"
                  v-for="(nav,index) in navlist" :key="index" @click="jump(nav.path,index)">
                     <div data-v-9c14ebd6="">{{nav.meta.title}}</div>
                  </div>
                  <a data-v-9c14ebd6="" class="nav-item" href="https://www.hlnwl.com" target="_blank" @click="showmenu = false">
                  官方网站 <i data-v-9c14ebd6="" class="iconfont icon-fenxiang_2"></i></a>
               </div>
             </div>
         </div>
      </div>
      <div class="sa-app">

         <router-view/>


         <div class="el-row sa-footer panel-block" style="" data-v-9c14ebd6>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-2 el-col-lg-3 el-col-xl-3" style="" data-v-9c14ebd6></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-20 el-col-lg-18 el-col-xl-18" style="" data-v-9c14ebd6>
                  
               <div class="el-row footer-container" style="" data-v-9c14ebd6>
                  
                  <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-16 el-col-lg-16 el-col-xl-16" style="" data-v-9c14ebd6>
                     
                     <div class="sa-flex left" data-v-9c14ebd6>
                        <div class="name" data-v-9c14ebd6>
							<div class="imgbox">
								 <a href="https://www.hlnwl.com" target="_blank" data-v-9c14ebd6>
								<img class="logo" src="@/assets/image/home/footer-logo.png" data-v-9c14ebd6>
								                              </a>
							</div>
                          <!-- <img class="logo" src="@/assets/image/home/footer-logo.png" data-v-9c14ebd6> -->
                           <div class="sa-flex" data-v-9c14ebd6>
                              <!-- <a class="icon" href="https://www.hlnwl.com" target="_blank" data-v-9c14ebd6>
                                 <img class="logo" src="@/assets/image/home/footer-logo.png" data-v-9c14ebd6>
                              </a> -->
                              <a class="icon" href="https://gitee.com/" target="_blank" data-v-9c14ebd6>
                                 <i class="iconfont icon-gitee-01" data-v-9c14ebd6></i>
                              </a>
                              <a class="icon" href="https://gitee.com" target="_blank" data-v-9c14ebd6>
                                 <i class="iconfont icon-github" data-v-9c14ebd6></i>
                              </a>
                           </div>
                        </div>
                        <div class="center" data-v-9c14ebd6>
                           <div class="sa-flex sa-flex-wrap" data-v-9c14ebd6>
							   <div data-v-9c14ebd6="" class="menu"
							   v-for="(nav,index) in navlist" :key="index" @click="jump(nav.path,index)">
							      <div data-v-9c14ebd6="">{{nav.meta.title}}</div>
							   </div>
                              <!-- <div class="menu" href="./" data-v-9c14ebd6 @click="jump('/',0)">首页</div>
                              <a class="menu" href="/function" @click="jump('/function',1)" data-v-9c14ebd6>功能介绍</a>
                              <a class="menu" href="/commission" data-v-9c14ebd6>思维导图</a>
                              <a class="menu" href="/buy" data-v-9c14ebd6>购买授权</a>
                              <a class="menu" href="/preview" data-v-9c14ebd6>系统演示</a> -->
                              <a class="menu" href="https://www.hlnwl.com" target="_blank" data-v-9c14ebd6>官方网站</a>
                           </div>
                           <div class="copyright" data-v-9c14ebd6>Copyright © 2017 - 2022 hlnwl.com Cloud. All Rights Reserverd. 火烈鸟科技 版权所有 </div>
                           <div class="company sa-flex sa-flex-wrap" data-v-9c14ebd6>
                              <div class="sa-m-b-8 sa-flex" data-v-9c14ebd6>
                                 <img class="gaoxin sa-m-r-4" src="@/assets/image/home/gaoxin.png" data-v-9c14ebd6>
                                 <span class="sa-m-r-8" data-v-9c14ebd6>国家科技型中小企业</span>
                              </div>
                              <div class="sa-m-b-8 sa-flex" data-v-9c14ebd6>
                                 火烈鸟科技有限公司<a class="sa-m-l-8" href="https://beian.miit.gov.cn/" target="_blank" data-v-9c14ebd6>豫ICP备17025401号</a>
                              </div>
                           </div>
                        </div>
                     </div>
                     
                  </div>
                  <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-8 el-col-lg-8 el-col-xl-8" style="" data-v-9c14ebd6>
                     <div class="right" data-v-9c14ebd6>
                        <div class="right-container" data-v-9c14ebd6>
                           <div class="contact" data-v-9c14ebd6>关注或联系我们 </div>
                           <div class="add" data-v-9c14ebd6>添加火烈鸟科技公众号，关注最新咨询 </div>
                           <div class="sa-flex" data-v-9c14ebd6>
                              <img class="qrcode-1" src="@/assets/image/home/qrcode-1.png" data-v-9c14ebd6>
                              <img class="qrcode-2" src="@/assets/image/home/qrcode-2.png" data-v-9c14ebd6>
                           </div>
                           <div class="consult sa-flex sa-flex-wrap" data-v-9c14ebd6>
                              <span class="left" data-v-9c14ebd6>咨询我们：</span>
                              <span data-v-9c14ebd6>18100330067 | 17760793207</span>
                           </div>
                           <div class="copyright" data-v-9c14ebd6>
                              <div data-v-9c14ebd6>Copyright © 2017 - 2022 SheepJS Cloud.</div>
                              <div class="sa-flex sa-row-center" data-v-9c14ebd6>
                                 <img class="gaoxin sa-m-r-4" src="@/assets/image/home/gaoxin.png" data-v-9c14ebd6>
                                 <span class="sa-m-r-8" data-v-9c14ebd6>国家科技型中小企业</span>
                              </div>
                              All Rights Reserverd. 火烈鸟科技 版权所有 
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-2 el-col-lg-3 el-col-xl-3" style="" data-v-9c14ebd6></div>
         </div>
         <div class="float-btn" data-v-9c14ebd6>
            <div class="float-box" data-v-9c14ebd6>
               <div class="float-qq" data-v-9c14ebd6>
                  <div class="qq-box" data-v-9c14ebd6>QQ:84086710 </div>
               </div>
               <div class="float-service" data-v-9c14ebd6>
                  <div class="qrcode-box" data-v-9c14ebd6>
                     <div class="qrcode-content" data-v-9c14ebd6>
                        <img class="qrcode-img" src="@/assets/image/home/wechat-qrcode.png" data-v-9c14ebd6>
                        <div class="qrcode-title" data-v-9c14ebd6>企业微信扫码咨询 </div>
                        <div class="qrcode-tel" data-v-9c14ebd6>
                           <img class="tel-img" src="@/assets/image/home/phone.png" data-v-9c14ebd6>
                           <div data-v-9c14ebd6>18100330067</div>
                        </div>
                     </div>
                  </div>
               </div>
               <div data-v-9c14ebd6="" class="backtop-box" @click="scrolltop">
                  <img data-v-9c14ebd6="" class="backtop-img" src="@/assets/image/home/backtop.png">
               </div>
            </div>
         </div>
         

      </div>

   </div>
</template>
<script>
   import router from '@/router/index';
   import { mapState,mapGetters,mapMutations,mapActions} from 'vuex'
   export default {
      name: '',
      data(){
         return{
            navlist:router.options.routes,
            currend: 0,
            showmenu: false,
            height:0
         }
   },
      watch: {
         showmenu(a, b) {
            if (a) {
               this.height = '100vh'
            } else {
               this.height = '0'
            }
         }
      },
      methods:{
         ...mapMutations(['getState']),
         scrolltop(){
            window.scrollTo({top: 0, behavior:'smooth'});
         },
         jump(path,index){
            this.showmenu = false;
            this.getState({index})
            this.$router.push(path,()=>{})
         }
      },
   mounted() {
         this.getState({ index:this.$route.meta.index})
         document.addEventListener("scroll", function(e){
            var t =document.documentElement.scrollTop||document.body.scrollTop;
            var headerTop = document.querySelector(".sa-header");
            var backtop = document.querySelector(".backtop-box");
            
            if( t > 0) {
               headerTop.style.background="#fff";
               headerTop.style.boxShadow="0 3px 8px #2626260f";
            }else{
               headerTop.style.background="rgba(255,255,255,0)";
               headerTop.style.boxShadow="0 3px 8px #26262600";
            }

            if( t > 100) {
               backtop.style.opacity="1";
               backtop.style.display="flex";
            }else{
               backtop.style.opacity="0";
               setTimeout(()=>{
                  backtop.style.display="none";
               },1000)
            }
         });
      }
   };
</script>
<style lang="sass">
   @import './assets/css/entry.css'
   @import './assets/css/default.css'
   @import './assets/css/iconfont.css'
</style>
